'use es6';

export const getActiveListLimitReached = state => {
  return state.get('details').get('listLimits') ? state.get('details').get('listLimits').get('activeListLimitReached') : false;
};
export const getStaticListLimitReached = state => {
  return state.get('details').get('listLimits') ? state.get('details').get('listLimits').get('staticListLimitReached') : false;
};